import { FindPageDetailsAjax } from './find-page-details.backend-model';
import { FindPageDetails } from './find-page-details.model';

export function transformFindPageDetails(
  response: FindPageDetailsAjax,
): FindPageDetails {
  return {
    id: response.seo_url,
    header: response.header,
    subheader: response.subheader !== '' ? response.subheader : undefined,
    formPlaceholder: response.formPlaceholder
      ? response.formPlaceholder
      : undefined,
    categoryId: response.category_id,
    featured_freelancer_id: response.featured_freelancer_id,
  };
}
